
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedInleftRight75 as ObiThreewayStackedInleftRight75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-inleft-right-75.js';
 
 
 

 
 export const ObiThreewayStackedInleftRight75 = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-inleft-right-75',
   elementClass: ObiThreewayStackedInleftRight75Element,
   events: {
     
   }
  });
 
 